import Editor from '@monaco-editor/react';

interface CodeContent {
  language?: string;
  code: string;
}

interface CodeRendererProps {
  content: CodeContent;
  editable: boolean;
  onChange: (newContent: CodeContent) => void;
}

function CodeRenderer({ content, editable, onChange }: CodeRendererProps) {
  return (
    <Editor
      height="300px"
      language={content.language ?? 'javascript'}
      value={content.code}
      options={{
        readOnly: !editable,
        minimap: { enabled: false },
        scrollBeyondLastLine: false,
        fontSize: 13,
      }}
      onChange={(value) => onChange({ ...content, code: value ?? '' })}
    />
  );
}

export default CodeRenderer;
